import { PropsWithChildren } from 'react';

import { Actions, Subjects } from './types';
import { useAbility } from './useAbility';

type AbilityGuardProps = PropsWithChildren<{
  action: Actions;
  subject: Subjects;
}>;

export const AbilityGuard = ({
  action,
  subject,
  children,
}: AbilityGuardProps) => {
  const ability = useAbility();

  if (ability.cannot(action, subject)) {
    return null;
  }

  return <>{children}</>;
};
